import { Container, Stack } from '@mui/material'
import { Outlet } from 'react-router-dom'
import OneTrustModal from '@/features/analytics/oneTrust/OneTrustModal'
import { useGTMPageChange } from '@/features/analytics/useGTMPageChange'
import { getAuthState } from '@/features/auth/slice'
import { DebugPanel } from '@/features/dev/DebugPanel'
import { getMediaState } from '@/features/media/slice'
import { MediaDetailsDrawer } from '@/features/media-details/Drawer'
import ToastSnackbar from '@/features/toasts/components/ToastSnackbar'
import { useAppSelector } from '@/redux/hooks'
import LoadingMessage from '../components/feedbacks/LoadingMessage'
import Footer from './Footer'
import Header from './header/Header'
import { NavigateToMain } from './NavigateToMain'
import { PageErrorBoundary } from './pages/errors/PageErrorBoundary'

type Props = {
  lockedHeight?: boolean
}

export function PageLayout(props: Props) {
  const { lockedHeight = true } = props
  const authState = useAppSelector(getAuthState)
  const isPerkins: boolean = useAppSelector(getMediaState).isPerkins

  useGTMPageChange(isPerkins)

  if (!authState.isAuthenticated) {
    return <LoadingMessage isAuthMessage={true} />
  }

  return (
    <>
      <NavigateToMain />
      <Stack
        minHeight="100dvh"
        height={lockedHeight ? '100dvh' : undefined}
        gap={2}
      >
        <Header />
        <Container id="main" tabIndex={-1} maxWidth="xl" sx={{ flexGrow: 1 }}>
          <PageErrorBoundary>
            <Outlet />
          </PageErrorBoundary>
        </Container>
        <Footer />
      </Stack>

      <ToastSnackbar />
      <OneTrustModal open={authState.oneTrustState.open} />
      <MediaDetailsDrawer />
      <DebugPanel />
    </>
  )
}
